export default __webpack_public_path__ + "locales/si/DeleteProfileEverDialog.json?hash=5e9c3a9ab41d6ad53a661be1897a6a80";